import React from "react";
import moment from "moment";
import { planDetailsType } from "custom-prop-types";

export const AccountUsage = ({ planDetails }) => (
  <div>
    <h1>Account Usage</h1>

    <div>
      <h2>Current Usage</h2>
      Current mail-in and digital usage: { " " }
      { dateFormatter(planDetails.periodStart) } – { dateFormatter(planDetails.periodEnd) }.
    </div>

    <div>{ planDetails.totalProcessedCount } items uploaded.</div>
    <div>{ planDetails.billableEnvelopeCount } Magic Envelopes received.</div>

    <div>
      Submissions currently in processing are not included in this usage total.<br />
      They will be added when processing is complete.<br />
      Envelopes are counted on the day they are received.
    </div>

    <h2>Excess Usage</h2>

    <div>
      Your current plan has a document excess usage fee of: ${ planDetails.overageFeePerDocument } per document,<br />
      when you exceed { planDetails.documentLimitPerMonth } documents in a month.<br />
      You have a Magic Envelope excess usage fee of:<br />
      $5.50 per Magic Envelope received,<br />
      when you exceed { planDetails.envelopeLimitPerMonth } Magic Envelopes in a month.
    </div>
    Learn more
  </div>
);

AccountUsage.propTypes = {
  planDetails: planDetailsType.isRequired
};

const dateFormatter = (date) => moment(date).format("D MMMM YYYY");



// WEBPACK FOOTER //
// ./src/js/components/settings/account-usage.jsx